export interface NewsArticle {
  id: string;
  title: string;
  date: string;
  author: string;
  category: string;
  summary: string;
  cover: string;
  tags: string[];
  content: string[];
}

export const newsCategories = ["影视资讯", "影评", "票房", "剧集情报"];

export const newsList: NewsArticle[] = [
  {
    id: "1",
    title: "《星际回响》首映礼落幕，硬科幻视效获赞“年度惊喜”",
    date: "2026-10-12",
    author: "泡泡影视编辑部",
    category: "影视资讯",
    summary:
      "备受期待的硬科幻大片《星际回响》于昨晚举行全球首映礼。影片以克制而宏大的叙事和细腻的情感线，让现场观众在片尾字幕升起时集体起立鼓掌。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20banner%20about%20a%20blockbuster%20premiere%20with%20a%20red%20carpet%20and%20camera%20flashes%2C%20deep%20blue%20night%20sky%20and%20warm%20orange%20spotlight%20glow%2C%20stylized%20editorial%20photography%20feel%2C%20elegant%20composition%2C%20high%20detail&width=800&height=500&seq=news-cover-01&orientation=landscape",
    tags: ["星际回响", "首映", "科幻"],
    content: [
      "备受期待的硬科幻大片《星际回响》于昨晚在城市艺术中心举行了全球首映礼。红毯之上，导演艾略特·卡特携主创团队悉数登场，现场的闪光灯几乎未曾停歇。",
      "影片讲述了一支深空远征队在人类文明存续的紧要关头，携带着文明备份驶向未知星系的故事。与许多依赖密集特效轰炸的科幻片不同，《星际回响》将大量篇幅留给了人物之间克制而深沉的对话。",
      "首映结束后，多位影评人在社交平台上写道：“这是近些年少见地把科学想象与真实情感结合得如此自然的作品。”也有观众表示，片尾关于“回响”的那段独白让人久久无法平静。",
      "据悉，影片将于本周五正式登陆全国院线，并同步登陆海外多地市场。对于是否会有续集，导演在采访中卖了个关子：“如果观众愿意再次听见回响，我们或许还会出发。”",
    ],
  },
  {
    id: "2",
    title: "亚洲电影大奖提名公布，多部华语作品入围主要奖项",
    date: "2026-10-10",
    author: "林知微",
    category: "影视资讯",
    summary:
      "本年度亚洲电影大奖提名名单正式揭晓，多部华语影片入围最佳影片、最佳导演等重要奖项，青年导演的崛起成为今年最受关注的现象。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20banner%20about%20a%20film%20festival%20award%20ceremony%20featuring%20a%20golden%20trophy%20glowing%20on%20a%20dark%20stage%2C%20deep%20blue%20ambience%20with%20warm%20orange%20highlights%2C%20stylized%20cinematic%20composition%2C%20high%20detail&width=800&height=500&seq=news-cover-02&orientation=landscape",
    tags: ["电影奖", "提名", "华语电影"],
    content: [
      "本年度亚洲电影大奖提名名单于今日正式公布。在最佳影片的候选名单中，多部华语作品赫然在列，与来自日本、韩国、印度的优秀影片同台竞争。",
      "值得一提的是，本届提名中青年导演占据了大半席位。评委会在声明中表示，评审过程中最令人兴奋的，正是看到这么多年轻创作者用全新的语言讲述属于这个时代的故事。",
      "《长夜将明》凭借扎实的剧本与出色的群像刻画，入围最佳影片与最佳导演两项重量级提名；《潮汐之城》则获得了最佳原创配乐的提名。",
      "颁奖典礼将于下月中旬举行，届时本站将带来全程报道，敬请关注。",
    ],
  },
  {
    id: "3",
    title: "暑期档票房盘点：类型多元化成最大亮点",
    date: "2026-10-08",
    author: "周砚",
    category: "票房",
    summary:
      "今年的暑期档落下帷幕，票房结构呈现出明显的类型多元化趋势。科幻、悬疑、爱情、动画各有佳作，观众的选择比以往更加分散。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20banner%20about%20summer%20movie%20season%20with%20popcorn%20and%20a%20clapperboard%20on%20a%20stylized%20desk%2C%20warm%20orange%20and%20deep%20blue%20palette%2C%20playful%20modern%20flat%20lay%2C%20soft%20studio%20light%2C%20high%20detail&width=800&height=500&seq=news-cover-03&orientation=landscape",
    tags: ["票房", "暑期档", "数据分析"],
    content: [
      "随着最后一周的票房数据出炉，今年的暑期档正式收官。整体来看，票房总量保持稳健，而更值得关注的是影片类型的多元化。",
      "与前几年头部影片一枝独秀的格局不同，今年多部中小成本影片凭借口碑实现了长线放映。观众不再只被大场面吸引，扎实的故事和真诚的表达同样能带来可观的票房。",
      "数据还显示，二三线城市观众的观影频次持续上升，成为支撑整个档期的重要力量。业内人士认为，这意味着市场正变得更加健康与成熟。",
      "展望接下来的档期，多部备受期待的作品已经定档，市场热度有望延续。",
    ],
  },
  {
    id: "4",
    title: "专访《山海纪》导演苏牧云：我们想拍一部有烟火气的仙侠",
    date: "2026-10-06",
    author: "许清和",
    category: "影视资讯",
    summary:
      "作为今年最受关注的大制作之一，《山海纪·焚天》在特效之外，更想讲述普通人的挣扎与成长。导演苏牧云分享了这部剧背后的创作坚持。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20banner%20about%20a%20director%20interview%20with%20a%20stylized%20camera%20and%20spotlight%20in%20a%20studio%2C%20deep%20blue%20background%20with%20warm%20amber%20rim%20light%2C%20minimal%20cinematic%20composition%2C%20high%20detail&width=800&height=500&seq=news-cover-04&orientation=landscape",
    tags: ["山海纪", "导演专访", "仙侠"],
    content: [
      "在《山海纪·焚天》上线之前，外界对它的期待主要集中在视效上。然而看完前几集后，许多观众讨论最多的，却是主角身上那股“笨拙的真诚”。",
      "导演苏牧云在接受本站专访时说：“我们不想拍一个无所不能的英雄。真正打动人的，往往是那些明知道自己很渺小，却还是愿意往前挪一步的人。”",
      "为此，剧组在开拍前用了三个月时间打磨人物小传，甚至为配角写了完整的前史。“仙侠不该只有飞天遁地，也应该有市井的烟火气。”",
      "谈及未来的计划，苏牧云表示如果观众喜欢，团队愿意继续把这套世界观做下去，“让山海的故事再长一点”。",
    ],
  },
  {
    id: "5",
    title: "影评｜《长夜将明》：在雨夜里追问真相的重量",
    date: "2026-10-04",
    author: "韩沐",
    category: "影评",
    summary:
      "《长夜将明》用一场漫长的雨夜，包裹了一个关于坚持与妥协的命题。它没有给出标准答案，却让每个观众都在其中照见了自己。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20banner%20about%20animated%20films%20with%20colorful%20paper%20cutout%20characters%20floating%20on%20a%20deep%20blue%20background%2C%20warm%20orange%20accents%2C%20playful%20stylized%20illustration%2C%20joyful%20mood%2C%20high%20detail&width=800&height=500&seq=news-cover-05&orientation=landscape",
    tags: ["影评", "长夜将明", "悬疑"],
    content: [
      "《长夜将明》是一部需要耐心去看的电影。它用大量静谧的镜头，把观众带进那个始终下着雨的城市，也带进主角越来越紧绷的内心。",
      "影片最聪明的地方，在于它把一个悬疑故事的核，藏进了一个关于“要不要坚持”的日常选择里。真相固然重要，但更难回答的是：知道真相之后，你打算怎么办。",
      "主演的表演克制而精准，尤其是结尾那场几乎没有任何台词的戏，情绪的张力几乎溢出银幕。摄影与配乐的配合也相得益彰，雨声成了整部电影里最忠实的旁白。",
      "如果你喜欢在类型片的外壳下寻找一些更柔软的东西，《长夜将明》值得你在一个安静的夜晚慢慢看完。",
    ],
  },
  {
    id: "6",
    title: "《暗涌档案》续订第三季，原班人马确认回归",
    date: "2026-10-02",
    author: "泡泡影视编辑部",
    category: "剧集情报",
    summary:
      "口碑悬疑剧《暗涌档案》正式宣布续订第三季，主演阵容确认悉数回归。制片方透露，新一季将把故事带到更早的年代。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20banner%20about%20streaming%20ratings%20charts%20with%20abstract%20glowing%20bar%20graphs%20on%20a%20dark%20blue%20dashboard%2C%20warm%20orange%20data%20accents%2C%20modern%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=news-cover-06&orientation=landscape",
    tags: ["暗涌档案", "续订", "悬疑剧"],
    content: [
      "让悬疑剧迷们等待许久的消息终于来了：口碑剧集《暗涌档案》正式宣布续订第三季，第二季结尾留下的悬念将在新一季中一一揭晓。",
      "制片方在接受采访时透露，第三季会把时间线往前推移，讲述那些被抹去的档案最初是如何形成的。“我们想回答的问题是：最初，是谁决定要删除它们。”",
      "主演艾米莉亚·克拉克与托马斯·里德已确认回归，导演团队也保持稳定。剧集预计明年开拍，后年与观众见面。",
    ],
  },
  {
    id: "7",
    title: "经典修复计划启动，多部老电影将重返大银幕",
    date: "2026-09-30",
    author: "林知微",
    category: "影视资讯",
    summary:
      "一项面向经典影片的修复计划正式启动，包括多部上世纪经典之作将经过4K修复后重新登上大银幕，让新一代观众有机会在大银幕上重温它们的魅力。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20banner%20about%20classic%20film%20restoration%20with%20vintage%20film%20reels%20and%20warm%20projector%20light%20beam%2C%20deep%20blue%20shadows%20and%20amber%20glow%2C%20nostalgic%20stylized%20composition%2C%20high%20detail&width=800&height=500&seq=news-cover-07&orientation=landscape",
    tags: ["经典修复", "老电影", "重映"],
    content: [
      "有些电影属于它们的时代，而有些电影属于所有时代。一项全新的经典影片修复计划于近日启动，首批入选片单涵盖了多部影响深远的老电影。",
      "据项目负责人介绍，修复工作不仅包括画面与声音的技术处理，还邀请了当年的摄影师与剪辑师参与把关，力求在还原胶片质感的同时，让它适应现代影厅的放映标准。",
      "首批修复影片将在未来一年内陆续重映。对于许多只在电视上见过它们的观众来说，这将是一次真正意义上的“第一次”。",
    ],
  },
  {
    id: "8",
    title: "幕后｜《深蓝之境》团队如何拍下那些从未被记录的深海画面",
    date: "2026-09-28",
    author: "周砚",
    category: "影视资讯",
    summary:
      "为了记录深海里那些从未被镜头捕捉过的生命，纪录片《深蓝之境》的团队在海上漂泊了整整两百天。这次，他们分享了镜头背后的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20banner%20about%20a%20sci-fi%20series%20behind%20the%20scenes%20with%20futuristic%20props%20and%20blue%20orange%20lighting%2C%20stylized%20concept%20art%20composition%2C%20cinematic%20atmosphere%2C%20high%20detail&width=800&height=500&seq=news-cover-08&orientation=landscape",
    tags: ["深蓝之境", "纪录片", "幕后"],
    content: [
      "《深蓝之境》播出后，许多观众都好奇一个问题：那些在漆黑深海发光的生物，究竟是怎么被拍到的？",
      "摄制团队在采访中坦言，最难的不是技术，而是等待。“我们常常在同一个位置下潜几十次，只为了等一个生命自己游进画面。有时候等一整个星期，什么也没等到。”",
      "为了不惊扰深海生物，团队研发了全新的低干扰照明设备，把光线强度控制到最低。这也意味着每一帧画面都需要大量的后期处理。",
      "“我们不是去征服海洋，而是去拜访它。”导演在片尾的这句话，或许就是整部纪录片最好的注解。",
    ],
  },
];